import { Injectable } from '@angular/core';
import { ReportesRequestService } from './request/reportes-request.service';

@Injectable({
  providedIn: 'root'
})
export class ServicioResolucion0256Service {

  constructor(private requestUrl: ReportesRequestService) { }

  async getEntidadEmpresarial(codigoBaseDatos: DatosBaseResolucionEntity, uncoEntidadEmpresarial: number) {
    try {
      const response = await this.requestUrl.getRequest(
        'entidad-empresarial/datos-entidad',
        [codigoBaseDatos.codigoBaseDatos, { unco_entidad_empresarial: uncoEntidadEmpresarial }]
      );
      return response;

    } catch (e) {
      alert(e);
      // console.log(`ServicioResolucion1552Service.getEntidadEmpresarial() ${e}`);
    }
    return null;
  }

  async getEmpresa(CodigoBD: string) {
    try {
      const response = await this.requestUrl.getFilterRequest(
        'resolucion0256/empresas',
        [CodigoBD]
      );

      return response;

    } catch (e) {
      console.log(`ServicioResolucion0256Service.getEmpresa() ${e}`);
    }

    return null;
  }
// Este método envía los datos de los filtros seleccionados al Spring y retorna la consulta de la Bases de Datos. D.C
  async getResolucionDataSp2(parametrosReporte: FiltrosResolucionEntity) {
    try {
      const responseSp2 = await this.requestUrl.getRequest(
        'resolucion0256/reporte-resolucion0256sp2',
        [
          parametrosReporte.codigoBaseDatos,
          {
            'fecha_inicial': parametrosReporte.fechaInicial,
            'fecha_final': parametrosReporte.fechaFinal,
            'unco_empresa': parametrosReporte.empresa,
          }
        ]);
      return responseSp2;
    } catch (e) {
      console.log(`ServicioResolucion0256Service.getResolucionDataSp2() ${e}`);
    }
  }
  async getResolucionDataSp4 (objetoReporte: FiltrosResolucionEntity) {
    try {
      const responseSp4 = await this.requestUrl.getRequest(
        'resolucion0256/reporte-resolucion0256sp4',
        [
          objetoReporte.codigoBaseDatos,
          {
            'fecha_inicial': objetoReporte.fechaInicial,
            'fecha_final': objetoReporte.fechaFinal,
            'unco_empresa': objetoReporte.empresa,
          }
        ]);
      return responseSp4;
    } catch (e) {
      console.log(`ServicioResolucion0256Service.getConsolidadoData() ${e}`);
    }
  }

  async getResolucionDataSp6(objetoReporte: FiltrosResolucionEntity) {
    try {
      const responseSp6 = await this.requestUrl.getRequest(
        'resolucion0256/reporte-resolucion0256sp6',
        [
          objetoReporte.codigoBaseDatos,
          {
            'fecha_inicial': objetoReporte.fechaInicial,
            'fecha_final': objetoReporte.fechaFinal,
            'unco_empresa': objetoReporte.empresa,
          }
        ]);
      return responseSp6;
    } catch (e) {
      console.log(`ServicioResolucion0256Service.getConsolidadoData() ${e}`);
    }
  }
}

export interface EntidadEmpresarial {
  unco: number;
  nombreEntidad: string;
  nit: string;
  direccion: number;
  telefono: string;
}
export interface Empresa {
  unco: number;
  descripcionCorta: string;
  descripcionLarga: string;
}

export interface DatosBaseResolucionEntity {
  codigoBaseDatos: string;
  uncoSede: string;
  uncoLogin: number;
  uncoEntidad: string;
}

export interface FiltrosResolucionEntity {
  codigoBaseDatos: string;
  fechaInicial: number;
  fechaFinal: number;
  empresa: string;

}

export interface FiltrosResolucionSp2BodyEntity {
  tipoDeRegistro: string;
  consecutivo: string;
  tipoDocumento: string;
  numeroIdentificacion: string;
  fechaNacimiento: string;
  sexo: string;
  primerApellido: string;
  segundoApellido: string;
  primerNombre: string;
  segundoNombre: string;
  codigoEntidadAdministradora: string;
  tipoCita: string;
  codigoServicio: string;
  descripcionCups: string;
  fechaSolicitudCita: string;
  citaAsignada: string;
  fechaCita: string;
  fechaDeseadaUsuario: string;
  empresa: string;
}

export interface FiltrosResolucionSp2ExcelEntity {
  tipoDeRegistro: string;
  consecutivo: string;
  tipoDocumento: string;
  numeroIdentificacion: string;
  fechaNacimiento: string;
  sexo: string;
  primerApellido: string;
  segundoApellido: string;
  primerNombre: string;
  segundoNombre: string;
  codigoEntidadAdministradora: string;
  tipoCita: string;
  codigoServicio: string;
  descripcionCups: string;
  fechaSolicitudCita: string;
  citaAsignada: string;
  fechaCita: string;
  fechaDeseadaUsuario: string;
  empresa: string;
}

export interface FiltrosResolucionSp4BodyEntity {
  tipoDeRegistro: string;
  tipoDocumento: string;
  numeroIdentificacion: string;
  fechaNacimiento: string;
  sexo: string;
  primerApellido: string;
  segundoApellido: string;
  primerNombre: string;
  segundoNombre: string;
  codigoEntidadAdministradora: string;
  municipio: string;
  codigoServicio: string;
  fechaAsignacion: string;
  fechaCita: string;
  atribuible: string;
  noReprogramada: string;
}
export interface FiltrosResolucionSp4ExcelEntity {
  tipoDeRegistro: string;
  tipoDocumento: string;
  numeroIdentificacion: string;
  fechaNacimiento: string;
  sexo: string;
  primerApellido: string;
  segundoApellido: string;
  primerNombre: string;
  segundoNombre: string;
  codigoEntidadAdministradora: string;
  municipio: string;
  codigoServicio: string;
  fechaAsignacion: string;
  fechaCita: string;
  atribuible: string;
  noReprogramada: string;
}

export interface FiltrosResolucionSp6BodyEntity {
  tipoDeRegistro: string;
  tipoDocumento: string;
  numeroIdentificacion: string;
  fechaNacimiento: string;
  sexo: string;
  primerApellido: string;
  segundoApellido: string;
  primerNombre: string;
  segundoNombre: string;
  eapb: string;
  fechaIngreso: string;
  horaIngreso: string;
  fechaAtencion: string;
  horaAtencion: string;
}
export interface FiltrosResolucionSp6ExcelEntity {
  tipoDeRegistro: string;
  tipoDocumento: string;
  numeroIdentificacion: string;
  fechaNacimiento: string;
  sexo: string;
  primerApellido: string;
  segundoApellido: string;
  primerNombre: string;
  segundoNombre: string;
  eapb: string;
  fechaIngreso: string;
  horaIngreso: string;
  fechaAtencion: string;
  horaAtencion: string;
}
